import {
  aamErrorRedirect,
  mycaLiteErrorRedirect,
  invalidSessionErrorRedirect,
  insufficientPrivilegesErrorRedirect,
  invalidGatekeeperErrorRedirect,
  invalidLocaleErrorRedirect,
  unauthorizedErrorRedirect,
  composeRedirector,
} from '@americanexpress/rerouter';

export default function errorRouter({
  error, body, dest, locale = 'en-US', state, loginOpts = {},
}) {
  // Exit if the error does not contain a response object
  if (!error || !body) return false; // !error.response
  // setDomains(state);
  const { errors = [] } = body;
  const [errorBody = {}] = errors;
  const errorRedirector = composeRedirector([
    aamErrorRedirect,
    mycaLiteErrorRedirect,
    invalidSessionErrorRedirect,
    insufficientPrivilegesErrorRedirect,
    invalidGatekeeperErrorRedirect,
    invalidLocaleErrorRedirect,
    unauthorizedErrorRedirect,
  ]);
  const destination = errorRedirector({
    response: error,
    error: errorBody,
    body,
    dest,
    locale,
    loginOpts,
    state,
  });
  /*
  {
    redirectUrl,
    isRoute,
    redirectFunc,
  }
  */
  return destination;
}
